import { render, staticRenderFns } from "./discount-cart-item.vue?vue&type=template&id=5779c9c2&scoped=true"
import script from "./discount-cart-item.vue?vue&type=script&lang=js"
export * from "./discount-cart-item.vue?vue&type=script&lang=js"
import style0 from "./discount-cart-item.vue?vue&type=style&index=0&id=5779c9c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5779c9c2",
  null
  
)

export default component.exports